import { Component, OnInit } from "@angular/core";
import { LayoutService } from "./service/app.layout.service";
import { Router } from "@angular/router";
import { AuthService } from "../site/service/auth.service";
import { BaseComponent } from "../shared/base.component";
import { takeUntil } from "rxjs/operators";
@Component({
  standalone: false,
  selector: "app-profilemenu",
  templateUrl: "./app.profilesidebar.component.html",
})
export class AppProfileSidebarComponent
  extends BaseComponent
  implements OnInit
{
  displayName: string = "";

  constructor(
    public layoutService: LayoutService,
    private authService: AuthService
  ) {
    super();
    this.authService
      .isLoggedIn()
      .pipe(takeUntil(this.destroy$))
      .subscribe((loggedIn) => {
        if (loggedIn) {
          this.displayName = this.authService.getCurrentUserDisplayName() || "";
        } else {
          this.displayName = "";
        }
      });
  }

  get visible(): boolean {
    return this.layoutService.state.profileSidebarVisible;
  }

  set visible(_val: boolean) {
    this.layoutService.state.profileSidebarVisible = _val;
  }

  ngOnInit() {
    this.authService
      .isLoggedIn()
      .pipe(takeUntil(this.destroy$))
      .subscribe((loggedIn) => {
        if (loggedIn) {
          this.displayName = this.authService.getCurrentUserDisplayName() || "";
        } else {
          this.displayName = "";
        }
      });
  }

  getName() {
    return this.displayName;
  }

  async logout() {
    this.visible = false; // Hide sidebar before logout
    await this.authService.SignOut();
  }
}
